import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import { IStore } from 'src/interfaces/store';

/**
 * @description Get the multiple store ids from the stores array
 * @param stores - The stores array
 * @returns The multiple store ids
 */

export const extractStoreIds = (stores: IStore[]): string[] => {
    let result: string[] = [];
    if (!stores || stores.length === 0) return result;

    stores.length > 0 &&
        stores.forEach((item: IStore) => {
            const id = getDocumentId(item);
            if (id) result.push(id);
        });
    return result;
};
